
import React from 'react';
import BlockIcon from '@mui/icons-material/Block';

const Unauthorized = () => {
 
  return (
    <div className="unauthorized">
      <div className='started'><BlockIcon/> You don't have the permissions to this page</div>
    </div>
  );
};

export default Unauthorized;
